/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortfolioCreateFromTemplateRequest
 */
export interface PortfolioCreateFromTemplateRequest {
    /**
     * name of the new portfolio
     * @type {string}
     * @memberof PortfolioCreateFromTemplateRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioCreateFromTemplateRequest
     */
    order: number;
}

/**
 * Check if a given object implements the PortfolioCreateFromTemplateRequest interface.
 */
export function instanceOfPortfolioCreateFromTemplateRequest(value: object): value is PortfolioCreateFromTemplateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    return true;
}

export function PortfolioCreateFromTemplateRequestFromJSON(json: any): PortfolioCreateFromTemplateRequest {
    return PortfolioCreateFromTemplateRequestFromJSONTyped(json, false);
}

export function PortfolioCreateFromTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioCreateFromTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'order': json['order'],
    };
}

export function PortfolioCreateFromTemplateRequestToJSON(json: any): PortfolioCreateFromTemplateRequest {
    return PortfolioCreateFromTemplateRequestToJSONTyped(json, false);
}

export function PortfolioCreateFromTemplateRequestToJSONTyped(value?: PortfolioCreateFromTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'order': value['order'],
    };
}

